module.exports = __webpack_public_path__ + "img/dice-3-active.5da1bbe2.png";